import React from 'react'
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {errorToast, successToast} from "../../components/layout/ToastStyles";
import {Apis} from "../../util/data";
import {PageBackLabel} from "../../components/layout/PageBackLabel";
import PageSection from "../../components/layout/PageSection";
import PageTitle from "../../components/layout/PageTitle";
import PageContainer from "../../components/layout/PageContainer";
import CategoriaForm from "./CategoriaForm";


const CategoriaNew = () => {
  const navigate = useNavigate()

  const onCreate = async (categoria) => {
    await axios.post(Apis.PROD + '/categoria-producto',categoria)
      .then(res => {
        successToast("Categoria creada correctamente")
        navigate('/categoria')
      })
      .catch(err => {
        errorToast(err.response.data.message,6000)
      });
  }

  return (
    <PageContainer>
      <PageSection>
        <PageBackLabel text='Categorias' onClick={() => navigate('/categoria')}/>
        <PageTitle title={'Categoria nueva'}/>
      </PageSection>

      <PageSection>
        <CategoriaForm value={{}} onSubmit={(cat) => onCreate(cat)}/>
      </PageSection>
    </PageContainer>
  )
}

export default CategoriaNew;
